import React from 'react';
import { Link, useLocation } from '@tanstack/react-router';
import { docTabs, getActiveTab } from './docNav';
import styles from './DocTabs.module.css';

export const DocTabs: React.FC = () => {
  const location = useLocation();
  const activeTab = getActiveTab(location.pathname);

  return (
    <div className={styles.tabBar}>
      {docTabs.map((tab) => (
        <Link
          key={tab.id}
          to={tab.defaultRoute}
          className={`${styles.tab} ${activeTab?.id === tab.id ? styles.active : ''}`}
        >
          {tab.label}
        </Link>
      ))}
    </div>
  );
};
